import Vue from 'vue'
import toast from './Toast.vue'

const ToastTem = Vue.extend(toast);
let instance;
let timer = null;

let toastMessage = (options) => {
    if (!instance) {
        instance = new ToastTem()
        instance.vm = instance.$mount()
        document.body.appendChild(instance.vm.$el)
    }
    if (timer) {
        clearTimeout(timer)
        timer = null
        instance.show = false
        instance.message = ''
    }
    let time = 3000
    if (typeof options === 'string') {
        instance.message = options
    } else if (typeof options === 'object') {
        let {
            message,
            time,
            type
        } = options
        instance.message = message
        time = time || 3000
        instance.type = type || "info"
    } else {
        return
    }
    instance.show = true
    timer = setTimeout(() => {
        instance.show = false
        clearTimeout(timer)
        timer = null
        setTimeout(() => {
            instance.message = ''
        }, 500);

    }, time)
}
toastMessage.close = () => {
    if (timer) {
        clearTimeout(timer)
        timer = null
        instance.show = false
        setTimeout(() => {
            instance.message = ''
        }, 500);
    }
}

toastMessage.install = (Vue) => {
    Vue.prototype.$toast = toastMessage
}
export default toastMessage;